import React, { useState, useEffect, Suspense, lazy } from "react";
import Carousel from "react-spring-3d-carousel-2";
import { config } from "react-spring";
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";
import "./PriorBroadcasts.css";

// const Video = lazy(() => import("./video"));

export default function PriorBroadcasts() {
  let slides = [];
  const imgCDNURL = process.env.REACT_APP_CDN_LINK;
  const imgURL =  imgCDNURL+"lion/PriorBroadcasts/";
  const arrowimg = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const [BannerPics, setBannerPics] = useState([]);
  const audio = new Audio();
  audio.src = process.env.REACT_APP_CLICK_SOUND;

  const [state, setState] = useState({
    goToSlide: 0,
    offsetRadius: 4,
    showNavigation: false,
    config: config.gentle,
    draggable: true,
  });

 
  let xDown = null;
  let yDown = null;

  const getTouches = (evt) => {
    return (
      evt.touches || evt.originalEvent.touches // browser API
    ); // jQuery
  };

  const handleTouchStart = (evt) => {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
    audio.play();
  };

  const handleTouchMove = (evt) => {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      /*most significant*/
      if (xDiff > 0) {
        /* left swipe */
        setState({ goToSlide: state.goToSlide + 1, offsetRadius: 4 });
        audio.play();
      } else {
        /* right swipe */
        setState({ goToSlide: state.goToSlide - 1, offsetRadius: 4 });
        audio.play();
      }
    } else {
      if (yDiff > 0) {
        /* up swipe */
      } else {
        /* down swipe */
      }
    }
   
    /* reset values */
    xDown = null;
    yDown = null;
  };

  useEffect(() => {
    // Get the event pics from a JSON file hosted in the cdn
    async function fetchBannerPics() {
      try {
        const memoryPics = await axios.get(
        process.env.REACT_APP_CDN_LINK + "lion/PriorBroadcasts.json");
        // console.log(memoryPics.data);
        let memoryPicsData = memoryPics.data;
        for (var data of memoryPicsData) {
          slides.push({
            key: data.imgPath,
            content: (
              <a href={data.url} target="_blank">
                <img
                  src={imgURL + data.imgPath}
                  className="broadcastimagesvideo"
                />
              </a>
            ),
          });
        }
        // console.log("slides: " + JSON.stringify(slides));
        let BannerPicsData = slides.map((slide, index) => {
          return {
            ...slide,
            onClick: () => setState({ goToSlide: index, offsetRadius: 4 }),
          };
        });
        setBannerPics(BannerPicsData);
      } catch (err) {
        console.log(err);
      }
    }
    fetchBannerPics();
  }, []);

  return (
    <>
      <div className="broadcastsection">
       
        <div>
          <Container>
            <Row>
            <div className="broadcastheading"  >
           <div className="line1" />
           <div className="sectionheading"><h2>Transmisiones Previas</h2></div>
           <div className="line2" />
        </div>
            </Row>
            <Row>
              <Col lg={12} xl={12} md={12} sm={12}>
                <div
                  className="broadcastvideo"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                >
                  <Carousel
                    slides={BannerPics}
                    draggable={state.draggable}
                    goToSlide={state.goToSlide}
                    offsetRadius={state.offsetRadius}
                    showNavigation={state.showNavigation}
                    animationConfig={state.config}
                    goToSlideDelay="20000"
                    interval={20}
                  />
                </div>
                <div>
                  <img
                    src={arrowimg + "LA.png"}
                    className="leftarrow"
                    alt="leftnavigation"
                    onClick={() => {
                      setState({
                        goToSlide: state.goToSlide - 1,
                        offsetRadius: 4,
                      });
                      audio.play();
                    }}
                  />

                  <img
                    src={arrowimg + "RA.png"}
                    className="rightarrow"
                    alt="rightnavigation"
                    onClick={() => {
                      setState({
                        goToSlide: state.goToSlide + 1,
                        offsetRadius: 4,
                      });
                      audio.play();
                    }}
                  />
                </div>
              </Col>
              </Row>
             
          </Container>
        </div>
      </div>
           
    </>
  );
}
